import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offer } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  /** Full label. Shown at every width unless shortLabel is provided. */
  label?: React.ReactNode;
  /** Optional shorter label used on narrow screens. */
  shortLabel?: React.ReactNode;
  sublabel?: string;
  /** Highlighted yellow note shown directly under the button. */
  note?: React.ReactNode;
  /** Anchor target. Defaults to the offer block. */
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
}
export function CtaButton({
  label = offer.ctaLabel,
  shortLabel,
  sublabel = offer.ctaSubLabel,
  note,
  href = '#offer',
  size = 'md',
  fullWidth = false,
  className = ''
}: CtaButtonProps) {
  const sizes = size === 'lg' ? 'px-7 py-5 text-base sm:text-lg' : 'px-6 py-4 text-[15px] sm:text-base';
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'The Argentine Mindset',
        currency: 'USD',
        value: 14
      });
      return;
    }
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} style={{
    paddingLeft: "0px",
    paddingRight: "0px",
    marginLeft: "0px",
    marginRight: "0px"
  }} data-id="element-24" data-mp="3swapknt25n8l">
      <a href={href} onClick={handleClick} className={`group inline-flex ${fullWidth ? 'w-full' : ''} items-center justify-center gap-3 rounded-xl bg-celeste-500 font-display font-extrabold uppercase tracking-tight text-navy-950 shadow-[0_12px_34px_-14px_rgba(117,170,219,0.8)] transition-[transform,background-color,box-shadow] duration-200 ease-smooth hover:bg-celeste-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-300 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-950 active:scale-[0.985] ${sizes}`} style={{
      paddingTop: "11px",
      paddingBottom: "11px",
      alignItems: "flex-start",
      justifyContent: "center",
      paddingLeft: "52px",
      paddingRight: "52px",
      marginTop: "0px",
      marginBottom: "0px",
      gap: "8px",
      backgroundColor: "#25B3F5",
      backgroundImage: "none"
    }} data-id="element-25" data-mp="6ialpmrelu64">
        {shortLabel ? <>
            <span className="text-balance sm:hidden" data-id="element-26" data-mp="jh09z83ybta0">{shortLabel}</span>
            <span className="hidden sm:inline" data-id="element-27" data-mp="ehnnwpkwmq8h">{label}</span>
          </> : <span className="text-balance" data-id="element-28" data-mp="eif8z6gvl5ki">{label}</span>}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="2l7li4j0l5xe7" />
      </a>
      {note ? <p className="mt-2 text-center font-display text-sm font-bold text-sun" data-id="element-30" data-mp="2gbd7nixc2sdd">{note}</p> : null}
      {sublabel ? <p className="mt-3 text-xs font-medium tracking-wide text-white/55" style={{
      fontSize: "14px",
      paddingTop: "12px",
      paddingBottom: "12px"
    }} data-id="element-31" data-mp="vtc72suk077c">{sublabel}</p> : null}
    </div>;
}